export default __webpack_public_path__ + "static/media/snapchat.f6324859.png";